import React from "react";

export type NotificationModalContextProps = {
    showSuccessModal: (message: string) => Promise<void>;
    showErrorModal: (message: string) => Promise<void>;
}

export const NotificationModalContext = React.createContext<NotificationModalContextProps>({
    showSuccessModal: async (message: string) => {},
    showErrorModal: async (message: string) => {},
});

